import { Alert } from '@creditornot/cb-alert';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { localize } from 'common/utils';

import { Offer } from '../../types';

type Props = {
  isMultiChoice: boolean;
  language: Language;
  offers: Offer[] | null;
};

const PurchasabilityErrors = styled(Alert).attrs({ variant: 'error' })`
  margin-block-start: 8px;
`;

export const UnpurchasableOfferWarning = ({ isMultiChoice, offers, language }: Props) => {
  // Always keep the last known value for `offers` visible for better UX. The value for `offers` is `null` when the form
  // is in invalid state and purchasability validation cannot be done. Without this, unpurchasable item warning would
  // pop in and out while typing values to the form.
  const [lastKnownOffers, setLastKnownOffers] = useState(offers);
  useEffect(() => {
    if (offers === null) {
      return;
    }
    setLastKnownOffers(offers);
  }, [offers]);
  return lastKnownOffers && lastKnownOffers.length > 0 ? (
    <PurchasabilityErrors>
      <div>
        <FormattedMessage id="menu-option.option-value-disable-confirmation.unpurchasable-item-list-description" />
        {lastKnownOffers.length > 10 ? (
          <ul>
            {lastKnownOffers.slice(0, 9).map(item => (
              <li key={item.id} lang={language}>
                {localize(item.name, language)}
              </li>
            ))}
            <li>
              <FormattedMessage
                id="menu-option.option-value-disable-confirmation.unpurchasable-item-list-more"
                values={{ num: lastKnownOffers.length - 9 }}
              />
            </li>
          </ul>
        ) : (
          <ul>
            {lastKnownOffers.map(item => (
              <li key={item.id} lang={language}>
                {localize(item.name, language)}
              </li>
            ))}
          </ul>
        )}

        {isMultiChoice ? (
          <>
            <FormattedMessage id="menu-option.item-purchasability-hint-multi-choice.list-title" />
            <ul>
              <li>
                <FormattedMessage id="menu-option.item-purchasability-hint-multi-choice.num-option-values-hint" />
              </li>
              <li>
                <FormattedMessage id="menu-option.item-purchasability-hint-multi-choice.disabled-option-values-hint" />
              </li>
              <li>
                <FormattedMessage id="menu-option.item-purchasability-hint-multi-choice.max-count-hint" />
              </li>
              <li>
                <FormattedMessage id="menu-option.item-purchasability-hint-multi-choice.menu-item-min-choices-hint" />
              </li>
            </ul>
          </>
        ) : (
          <FormattedMessage id="menu-option.item-purchasability-hint-single-choice" />
        )}
      </div>
    </PurchasabilityErrors>
  ) : null;
};
